export interface Product {
  id: number;
  name: string;
  price: number;
  category: string;
  image: string[];
  description: string;
  colors: string[];
}

export const products: Product[] = [
  // Hoodies
  {
    id: 1,
    name: "Unleash Your Creativity",
    price: 1499.0,
    category: "hoodies",
    image: ["/images/product_mockup/Mockups (1).png"],
    colors: ["black", "white", "grey"],
    description: "",
  },
  {
    id: 2,
    name: "Sorry I'M late",
    price: 1499.0,
    category: "hoodies",
    image: ["/images/product_mockup/Mockups (3).png"],
    colors: ["black", "white", "grey"],
    description: "",
  },
  {
    id: 3,
    name: "Simple & Genius",
    price: 1499.0,
    category: "hoodies",
    image: ["/images/product_mockup/Mockups (4).png"],
    colors: ["black", "white", "grey"],
    description: "",
  },
  {
    id: 4,
    name: "Fearless",
    price: 1499.0,
    category: "hoodies",
    image: ["/images/product_mockup/Mockups (5).png"],
    colors: ["black", "white", "grey"],
    description: "",
  },
  {
    id: 5,
    name: "LIENZO",
    price: 1499.0,
    category: "hoodies",
    image: ["/images/product_mockup/Mockups (6).png"],
    colors: ["black", "white", "grey"],
    description: "",
  },
  {
    id: 6,
    name: "Born To Code",
    price: 1499.0,
    category: "hoodies",
    image: ["/images/product_mockup/Mockups (7).png"],
    colors: ["black", "white", "grey"],
    description: "",
  },
  {
    id: 7,
    name: "If You Are Not Broken",
    price: 1499.0,
    category: "hoodies",
    image: ["/images/product_mockup/Mockups (8).png"],
    colors: ["black", "white", "grey"],
    description: "",
  },
  {
    id: 8,
    name: "Unleash Fire",
    price: 1499.0,
    category: "hoodies",
    image: ["/images/product_mockup/Mockups (9).png"],
    colors: ["black", "white", "grey"],
    description: "",
  },
  {
    id: 9,
    name: "Redefine Your Style",
    price: 1499.0,
    category: "hoodies",
    image: ["/images/product_mockup/Mockups (10).png"],
    colors: ["black", "white", "grey"],
    description: "",
  },
  {
    id: 10,
    name: "Panorama",
    price: 1499.0,
    category: "hoodies",
    image: ["/images/product_mockup/Mockups (11).png"],
    colors: ["black", "white", "grey"],
    description: "",
  },
  {
    id: 11,
    name: "Friends",
    price: 1499.0,
    category: "hoodies",
    image: ["/images/product_mockup/Mockups (12).png"],
    colors: ["black", "white", "grey"],
    description: "",
  },
  {
    id: 12,
    name: "CHOOSE ME",
    price: 1499.0,
    category: "hoodies",
    image: ["/images/product_mockup/Mockups (13).png"],
    colors: ["black", "white", "grey"],
    description: "",
  },
  {
    id: 13,
    name: "Bro 🤝",
    price: 1499.0,
    category: "hoodies",
    image: ["/images/product_mockup/BRO.png"],
    colors: ["black", "white", "grey"],
    description: "",
  },
  {
    id: 14,
    name: "Unleash Your Creativity",
    price: 1499.0,
    category: "shirts",
    image: ["/images/product_mockup/2.png"],
    colors: ["black", "white", "grey"],
    description: "",
  },
  {
    id: 15,
    name: "Sorry I'M late",
    price: 1499.0,
    category: "shirts",
    image: ["/images/product_mockup/Mockups (3).png"],
    colors: ["black", "white", "grey"],
    description: "",
  },
  {
    id: 16,
    name: "Simple & Genius",
    price: 1499.0,
    category: "shirts",
    image: ["/images/product_mockup/Mockups (16).png"],
    colors: ["black", "white", "grey"],
    description: "",
  },
  {
    id: 17,
    name: "Fearless",
    price: 1499.0,
    category: "shirts",
    image: ["/images/product_mockup/Mockups (18).png"],
    colors: ["black", "white", "grey"],
    description: "",
  },
  {
    id: 18,
    name: "LIENZO",
    price: 1499.0,
    category: "shirts",
    image: ["/images/product_mockup/Mockups (27).png"],
    colors: ["black", "white", "grey"],
    description: "",
  },
  {
    id: 19,
    name: "Travel",
    price: 1499.0,
    category: "shirts",
    image: ["/images/product_mockup/Mockups (25).png"],
    colors: ["black", "white", "grey"],
    description: "",
  },
  {
    id: 20,
    name: "If You Are Not Broken",
    price: 1499.0,
    category: "shirts",
    image: ["/images/product_mockup/IF_YOU_ARE_NOT_BROKEN.png"],
    colors: ["black", "white", "grey"],
    description: "",
  },
  {
    id: 21,
    name: "Unleash Fire",
    price: 1499.0,
    category: "shirts",
    image: ["/images/product_mockup/4.png"],
    colors: ["black", "white", "grey"],
    description: "",
  },
  {
    id: 22,
    name: "Redefine Your Style",
    price: 1499.0,
    category: "shirts",
    image: ["/images/product_mockup/5.png"],
    colors: ["black", "white", "grey"],
    description: "",
  },
  {
    id: 23,
    name: "Panorama",
    price: 1499.0,
    category: "shirts",
    image: ["/images/product_mockup/Mockups (11).png"],
    colors: ["black", "white", "grey"],
    description: "",
  },
  {
    id: 24,
    name: "Friends",
    price: 1499.0,
    category: "shirts",
    image: ["/images/product_mockup/Mockups (22).png"],
    colors: ["black", "white", "grey"],
    description: "",
  },
  {
    id: 25,
    name: "CHOOSE ME",
    price: 1499.0,
    category: "shirts",
    image: ["/images/product_mockup/Mockups (13).png"],
    colors: ["black", "white", "grey"],
    description: "",
  },
  {
    id: 26,
    name: "Bro 🤝",
    price: 1499.0,
    category: "shirts",
    image: ["/images/product_mockup/Mockups (21).png"],
    colors: ["black", "white", "grey"],
    description: "",
  },
  {
    id: 27,
    name: "BEING ENGINEER 'CSE'",
    price: 1499.0,
    category: "shirts",
    image: ["/images/product_mockup/3.png"],
    colors: ["black", "white", "grey"],
    description: "",
  },
];
